export default {
  props: {
    isLoginPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async dispatch(action, payload) {
      this.loading = true;
      try {
        const result = await this.$store.dispatch(action, payload);
        return this.processResult(result);
      } finally {
        this.loading = false;
      }
    },

    /** @param {LoginResult} result */
    processResult(result) {
      if (!result.redirect) {
        return result;
      }

      if (result.redirect.path) {
        this.$router.push(result.redirect.path);
      } else if (result.redirect.name) {
        this.redirectToLoginPage(result.redirect.name, result.redirect.query);
      }
      return result;
    },

    redirectToLoginPage(loginPageId, query) {
      this.$emit('redirect', loginPageId, query);
    },
  },
};
